// removed by extract-text-webpack-plugin
module.exports = {"closed":"SideBarTasks__closed___2Pihk","taskbar":"SideBarTasks__taskbar___1vF9o","header":"SideBarTasks__header___22Qev","toggleCompleted":"SideBarTasks__toggleCompleted___Njx4I","taskSection":"SideBarTasks__taskSection___2AaKv","tabs":"SideBarTasks__tabs___2jg_Z","tab":"SideBarTasks__tab___uspud","tabscontainer":"SideBarTasks__tabscontainer___24Zl2","toggleLabel":"SideBarTasks__toggleLabel___q4Qxr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SideBarTasks/SideBarTasks.scss
// module id = 1194
// module chunks = 1